import _objectSpread from "/var/lib/jenkins/workspace/wyt-admin/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, isRef as _isRef } from "vue";
const _hoisted_1 = {
  class: "toolbox"
};
const _hoisted_2 = {
  class: "wrapper"
};

const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", {
  class: "label"
}, "用户名称", -1);

const _hoisted_4 = {
  class: "wrapper"
};

const _hoisted_5 = /*#__PURE__*/_createTextVNode("查询");

const _hoisted_6 = /*#__PURE__*/_createTextVNode("重置");

const _hoisted_7 = {
  style: {
    "text-align": "right",
    "padding-top": "10px"
  }
};

const _hoisted_8 = /*#__PURE__*/_createTextVNode("取消");

const _hoisted_9 = /*#__PURE__*/_createTextVNode("保存");

import { computed, ref, watch, reactive } from 'vue';
import { getSalesmanList } from '@/request';
import { getVexTableProps } from '@/config';
export default {
  name: 'user-modal',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    selectedList: {
      type: Array,
      default: () => []
    }
  },
  emits: ['update:modelValue', 'success'],

  setup(__props, {
    emit
  }) {
    const props = __props;
    const visible = computed({
      get() {
        return props.modelValue;
      },

      set(val) {
        emit('update:modelValue', val);
      }

    });
    const table = ref();
    const form = reactive({
      linkMan: ''
    });
    watch(() => props.modelValue, v => {
      if (v) {
        var _table$value;

        form.linkMan = '';
        selectedList.value = [...props.selectedList];
        (_table$value = table.value) === null || _table$value === void 0 ? void 0 : _table$value.commitProxy('reload');
      }
    });
    const tableOptions = getVexTableProps({
      columns: [{
        type: 'checkbox',
        width: '50px'
      }, {
        title: '用户名称',
        field: 'linkMan'
      }, {
        title: '登录账号',
        field: 'loginName'
      }, {
        title: '手机号',
        field: 'linkPhone'
      }, {
        title: '所属团队',
        field: 'supplierName'
      }],
      proxyConfig: {
        ajax: {
          query: ({
            page
          }) => new Promise(res => {
            getSalesmanList(_objectSpread({
              page: page.currentPage,
              rows: page.pageSize
            }, form)).then(data => {
              res({
                total: data.total,
                result: data.rows
              });

              if (selectedList.value.length) {
                setTimeout(() => {
                  let selectedRows = data.rows.filter(item => selectedList.value.find(v => v.supAccountId == item.supAccountId));
                  table.value.setCheckboxRow(selectedRows, true);
                }, 300);
              }
            });
          })
        }
      }
    });

    function checkboxVisibleMethod({
      row
    }) {
      return !props.selectedList.find(item => row.supAccountId == item.supAccountId);
    }

    const selectedList = ref([]);

    function tableSelectHandle(e) {
      let {
        row,
        checked
      } = e;
      let findIndex = selectedList.value.findIndex(v => v.supAccountId == row.supAccountId);

      if (checked && findIndex == -1) {
        selectedList.value.push(row);
      } else {
        selectedList.value.splice(findIndex, 1);
      }
    }

    function tableAllSelectHandle(e) {
      let {
        records,
        checked
      } = e;

      if (checked) {
        records.forEach(item => {
          if (selectedList.value.find(v => v.supAccountId == item.supAccountId)) return;
          selectedList.value.push(item);
        });
      } else {
        tableData.value.forEach(item => {
          let findIndex = selectedList.value.findIndex(v => v.supAccountId === item.supAccountId);

          if (findIndex > -1) {
            selectedList.value.splice(findIndex, 1);
          }
        });
      }
    }

    function submit() {
      emit('success', selectedList.value.map(v => ({
        supAccountId: v.supAccountId,
        linkMan: v.linkMan
      })));
      visible.value = false;
    }

    function resetHandle() {
      var _table$value2;

      form.linkMan = '';
      (_table$value2 = table.value) === null || _table$value2 === void 0 ? void 0 : _table$value2.commitProxy('reload');
    }

    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");

      const _component_el_button = _resolveComponent("el-button");

      const _component_vxe_grid = _resolveComponent("vxe-grid");

      const _component_el_dialog = _resolveComponent("el-dialog");

      return _openBlock(), _createBlock(_component_el_dialog, {
        modelValue: _unref(visible),
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => _isRef(visible) ? visible.value = $event : null),
        title: "选择黑名单用户",
        width: "70%",
        top: "5vh",
        "custom-class": "black-list-modal"
      }, {
        footer: _withCtx(() => [_createElementVNode("footer", _hoisted_7, [_createVNode(_component_el_button, {
          onClick: _cache[2] || (_cache[2] = $event => visible.value = false)
        }, {
          default: _withCtx(() => [_hoisted_8]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: submit
        }, {
          default: _withCtx(() => [_hoisted_9]),
          _: 1
        })])]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createVNode(_component_el_input, {
          modelValue: form.linkMan,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => form.linkMan = $event),
          placeholder: "请输入用户名称",
          style: {
            "width": "240px"
          }
        }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_4, [_createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[1] || (_cache[1] = $event => table.value.commitProxy('reload'))
        }, {
          default: _withCtx(() => [_hoisted_5]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: resetHandle
        }, {
          default: _withCtx(() => [_hoisted_6]),
          _: 1
        })])]), _unref(visible) ? (_openBlock(), _createBlock(_component_vxe_grid, _mergeProps({
          key: 0,
          ref_key: "table",
          ref: table
        }, _unref(tableOptions), {
          "checkbox-config": {
            checkMethod: checkboxVisibleMethod
          },
          onCheckboxChange: tableSelectHandle,
          onCheckboxAll: tableAllSelectHandle
        }), null, 16, ["checkbox-config"])) : _createCommentVNode("", true)]),
        _: 1
      }, 8, ["modelValue"]);
    };
  }

};